import { Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { Icon } from '../icon/icon';
import { WebSocketService } from '../../services/websocket-service';
import { ApiService } from '../../services/api-service';
import { DistancePipe } from '../../pipes/distance-pipe';
import { ElevationPipe } from '../../pipes/elevation-pipe';
import { SpeedPipe } from '../../pipes/speed-pipe';
import { UnitType } from '../../models/unit.model';
import { DurationPipe } from '../../pipes/duration-pipe';
import { DisplayAnimations } from '../../directives/display-animations';
import { SportType } from '../../models/sport.model';
import { TranslateModule } from '@ngx-translate/core';
import { UpperCasePipe } from '@angular/common';

@Component({
  selector: 'app-pause-overlay',
  templateUrl: './pause-overlay.html',
  styleUrl: './pause-overlay.scss',
  imports: [Icon, TranslateModule, UpperCasePipe],
  hostDirectives: [DisplayAnimations],
})
export class PauseOverlay {
  private webSocketService: WebSocketService = inject(WebSocketService);
  private apiService: ApiService = inject(ApiService);
  private clientUnit: UnitType = (localStorage.getItem('unit') as UnitType) || 'metric';
  private distancePipe: DistancePipe = new DistancePipe();
  private elevationPipe: ElevationPipe = new ElevationPipe();
  private speedPipe: SpeedPipe = new SpeedPipe();
  private durationPipe: DurationPipe = new DurationPipe();
  protected readonly sport: Signal<SportType> = computed(
    () => this.webSocketService.contentInformation()?.sport || 'cycling',
  );

  message: InputSignal<string | undefined> = input<string | undefined>();
  contentTitle: Signal<string> = computed(() => this.apiService.scenicInformation()?.name || '');

  completionPercent: Signal<number> = this.webSocketService.completionPercent;

  distance: Signal<string> = computed(() =>
    this.distancePipe.transform(
      this.webSocketService.broadcastData()?.data.distance || 0,
      this.clientUnit,
      'both',
    ),
  );

  elevation: Signal<string> = computed(() =>
    this.elevationPipe.transform(
      this.webSocketService.broadcastData()?.data.positiveSlope || 0,
      this.clientUnit,
      'both',
    ),
  );

  duration: Signal<string> = computed(() =>
    this.durationPipe.transform(
      this.webSocketService.broadcastData()?.data.time || 0,
      'adaptative',
    ),
  );

  speedAvr: Signal<string> = computed(() =>
    this.speedPipe.transform(
      this.webSocketService.broadcastData()?.data.avgSpeed || 0,
      this.clientUnit,
      'both',
      0,
    ),
  );

  cadenceAvr: Signal<number> = computed<number>(() =>
    Math.round(this.webSocketService.broadcastData()?.data.avgCadence || 0),
  );
}
